export default __webpack_public_path__ + "static/media/dropbox-logo.130feb93.png";